import request from '@/utils/request'

export const getPayrollRuns = params => request.get('/accounting/payroll-runs', { params })

export const createPayrollRun = data => request.post('/accounting/payroll-runs', data)

export const getPayrollRun = id => request.get(`/accounting/payroll-runs/${id}`)

export const updatePayrollLine = (runId, lineId, data) => request.put(
  `/accounting/payroll-runs/${runId}/lines/${lineId}`,
  data,
)

export const accruePayrollRun = id => request.post(`/accounting/payroll-runs/${id}/accrue`)

export const payPayrollRun = (id, data) => request.post(`/accounting/payroll-runs/${id}/pay`, data)

export const cancelPayrollRun = id => request.post(`/accounting/payroll-runs/${id}/cancel`)
